import { TranslatePipe } from './../../../../shared/translate/pipes/translate.pipe';
import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    loader: HTMLIonLoadingElement;

    constructor(private loadingController: LoadingController, private translatePipe: TranslatePipe) { }

    async presentLoading(msg: string): Promise<any> {
        this.dismissLoading();
        return new Promise(async (resolve, reject) => {
            this.loader = await this.loadingController.create({
                message: this.translatePipe.transform(msg),
            });
            await this.loader.present();
            resolve();
        });
    }

    dismissLoading() {
        if (this.loader) {
            this.loader.dismiss();
        }
    }
}
